import i18n from 'sharedKernel/i18n/translate/config'
import { trans } from 'sharedKernel/i18n'
import { IPublicFormSettings } from './api/settingsMappers'
import {
  getMaxSpacesWhenEmpty,
  resolvePurposeRules,
  selectionUsesEventRules,
} from './purposeRules'
import { IPublicMeetingRoom, IPublicMeetingRoomReservationRules } from './types'

const buildSpacesLimitMessage = (
  count: number,
  forEvents: boolean
): string =>
  i18n.t(
    forEvents
      ? 'meetingRoom.public.rules.maxSpacesSelectable.event'
      : 'meetingRoom.public.rules.maxSpacesSelectable.meeting',
    { count }
  )

export const getPublicMeetingRoomRules = (
  settings: IPublicFormSettings | null = null,
  selectedRooms: IPublicMeetingRoom[] = []
): IPublicMeetingRoomReservationRules => {
  const hasSelection = selectedRooms.length > 0
  const purposeRules = hasSelection
    ? resolvePurposeRules(selectedRooms, settings)
    : {
        spacesLimit: getMaxSpacesWhenEmpty(settings),
        daysLimit: 1,
        minLeadTime: 0,
        maxDurationMinutes: null,
        eventInterestDemonstration: false,
      }

  const infoItems = [
    trans('meetingRoom.public.rules.calendarUpdatedDaily'),
    trans('meetingRoom.public.rules.requestNotGuaranteed'),
  ]

  if (hasSelection) {
    infoItems.push(
      buildSpacesLimitMessage(
        purposeRules.spacesLimit,
        selectionUsesEventRules(selectedRooms)
      )
    )
  } else if (settings != null) {
    infoItems.push(buildSpacesLimitMessage(Math.max(settings.eventSpacesLimit || 1, 1), true))
    infoItems.push(buildSpacesLimitMessage(Math.max(settings.meetingSpacesLimit || 1, 1), false))
  } else {
    infoItems.push(buildSpacesLimitMessage(purposeRules.spacesLimit, true))
  }

  return {
    maxSelectableSpaces: purposeRules.spacesLimit,
    infoItems,
  }
}
